import { Box, Button, CardMedia, Grid, Typography, useMediaQuery } from "@mui/material"
import visionImage from '../../assets/image/landing/vision.png';
import missionImage from '../../assets/image/landing/mission.png';

const goals = [
    {
        title: "Vision",
        description: "To become the leading local defense, technology, and infrastructure provider in the Philippines, enhancing national security and self-reliance.",
        image: visionImage, 
    },
    {
        title: "Mission",
        description: "Develop and deliver high-quality, locally produced defense systems, technologies, and infrastructure through strategic collaborations and innovation.",
        image: missionImage, 
    },
   
];

const LandingStrategicGoalsComponent = () => {

    const isSmallScreen = useMediaQuery('(max-width:600px)'); 


    return (
       
        <div  style={{backgroundColor: '#08244d', color: '#fff', padding: 28}}>
            <Grid container sx={{ textAlign: 'start', position: 'relative', marginTop: 4 }}>
                <Grid item xs={12}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 60, textAlign: 'center' }}>
                        Strategic Goals
                    </Typography>
                    <br />
                </Grid>
                {goals.map((goal, index) => (
                <Grid item xs={12} sm={6} key={index}>
                    <Box sx={{padding: isSmallScreen ? 0 : 16, pt: isSmallScreen ? 0 :  3, pb: isSmallScreen ? 0 :  3, margin: isSmallScreen ? 1 : 0}}>
                    <CardMedia
                        component="img"
                        height="320"
                        image={goal.image}
                        alt={goal.title}
                    />
                    <Typography sx={{fontSize: 40, fontWeight: 'bold', mb:1, mt:1}}>{goal.title}</Typography>
                    <Typography sx={{fontSize: 24, textAlign: 'justify'}}>{goal.description}</Typography>
                    </Box>
                </Grid>
                ))}
            </Grid>
        </div>
    )
}

export default LandingStrategicGoalsComponent